// Shared reflow utility strings for the legacy lesson overview cards layout.
// Both card variants (Cards/Card.tsx and Staffer/Student TeacherCard) compose their root from
// Cards.module.scss `.card` (width: 18.125rem; margin: 1.1875rem), so they share the same reflow override.
// The cards-row container is also shared between LessonOverview.tsx and TeacherSlideShows.tsx.

export const CARDS_ROW_REFLOW = 'tw-w-auto tw-justify-center reflow-narrow:tw-justify-start';

export const CARD_ROOT_REFLOW = 'tw-w-full tw-max-w-[18.125rem] tw-box-border tw-my-6 tw-mx-0 reflow-narrow:tw-w-[18.125rem] reflow-narrow:tw-max-w-none reflow-narrow:tw-m-[1.1875rem]';
